import { useEffect, useState } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";
import HomePage from "layouts/pages/home";
import RoutesConfig from "routes";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

export default function App() {
  const [stripePromise, setStripePromise] = useState(null);
  const { pathname } = useLocation();
  const routes = RoutesConfig();
  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  useEffect(() => {
    loadStripe(
      "pk_live_51H5yPaFg70n6cQgGCMS3UXuzG2iSQeS2DgQGo1IC2hmoIyYTKijTSDJnHYZMf0ntcezYryHLH3TP1HcI7kBb7s5O00HRTQ2L2N"
    ).then((stripe) => {
      setStripePromise(stripe);
    });
  }, []);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <Elements stripe={stripePromise}>
        <CssBaseline />
        <Routes>
          {getRoutes(routes)}
          <Route path="/" element={<HomePage />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Elements>
    </ThemeProvider>
  );
}
